import MobileHelper from './MobileHelper';
import IndexedDBHelper from './IndexedDBHelper';
import { SAVE_LOCATION } from '../const';
import { lastAccessTime } from '../utils/date';
const DOC_ALLOW_FILE = 'image/*,.pdf,.doc,.xls,.ppt,.hwp,.docx,.xlsx,.pptx,.zip';

const MAX_SIZE = 20971520;
const MAX_COUNT = 3;
const ALLOW_FILE_DOC = '.pdf,.doc,.xls,.ppt,.hwp,.docx,.xlsx,.pptx,.zip';
const ALLOW_FILE_IMG = '.jpg,.jpeg,.png,.bmp,.ai,.gif,tif';

export default {
    allowFileExt: () => {
        const platform = MobileHelper.getWebViewPlatform();
        if (platform === 'android') return '';
        return DOC_ALLOW_FILE;
    },
    isCount: count => {
        if (MAX_COUNT <= count) {
            alert('최대 파일 허용개수는 ' + MAX_COUNT + ' 입니다.');
            return false;
        }
        return true;
    },
    isSize: size => {
        if (MAX_SIZE < size) {
            alert('20MB이내로 첨부가 가능합니다.');
            return false;
        }
        return true;
    },
    isAllowFile: fileName => {
        const fileExt = ALLOW_FILE_DOC + ',' + ALLOW_FILE_IMG;
        const ext = fileName.split('.').pop() || '';
        if (fileExt.indexOf(ext) < 0) {
            alert('첨부가능한 파일이 아닙니다.');
            return false;
        }
        return true;
    },
    appFileDownload: (fileData, movi) => {
        const blob = fileData.blob;
        const filename = fileData.fileName;
        let storageLocation = '';
        const saveLocation = localStorage.getItem(SAVE_LOCATION) || 'a';
        const moviData = { ...movi };
        switch (window.device.platform) {
            case 'Android':
                storageLocation = window.cordova.file.dataDirectory;
                break;
            case 'iOS':
                storageLocation = window.cordova.file.syncedDataDirectory; //icloud
                if (saveLocation === 'a') {
                    storageLocation = window.cordova.file.dataDirectory; //no icloud
                }
                break;
        }

        const folderPath = storageLocation;
        console.log('folderPath::' + folderPath);

        window.resolveLocalFileSystemURL(
            folderPath,
            function(dir) {
                dir.getFile(
                    filename,
                    {
                        create: true
                    },
                    function(file) {
                        file.createWriter(
                            function(fileWriter) {
                                fileWriter.write(blob);

                                fileWriter.onwriteend = function() {
                                    const url = file.toURL();
                                    console.log('fileUrl:' + url);
                                    if (saveLocation === 'a') {
                                        window.cordova.plugins.photoLibrary.requestAuthorization(
                                            function() {
                                                window.cordova.plugins.photoLibrary.saveVideo(
                                                    url,
                                                    'cds.live',
                                                    function(result) {
                                                        console.log('result:::' + JSON.stringify(result));
                                                    },
                                                    function(err) {
                                                        console.log(err);
                                                    }
                                                );
                                            },
                                            function() {
                                                // User denied the access
                                            }, // if options not provided, defaults to {read: true}.
                                            {
                                                read: false,
                                                write: true
                                            }
                                        );
                                    }

                                    moviData.localPath = url;
                                    moviData.regDate = lastAccessTime();
                                    IndexedDBHelper.openMoviDB(result => {
                                        IndexedDBHelper.putMovi(moviData, result);
                                    });
                                };
                                fileWriter.onerror = function(err) {
                                    alert('Unable to download');
                                    console.error(err);
                                };
                            },
                            function(err) {
                                // failed
                                alert('Unable to download');
                                console.error(err);
                            }
                        );
                    },
                    function(err) {
                        alert('Unable to download');
                        console.error(err);
                    }
                );
            },
            function(err) {
                alert('Unable to download');
                console.error(err);
            }
        );
    }
};
